module.exports = __webpack_public_path__ + "img/bryan2.59873c55.jpg";